export interface ITeamPermissions {
  mlb_stats_api: boolean;
}

export interface IMachinePermissions {}

export interface IUserPermissions {
  machine_lists: boolean;
  team_lists: boolean;
}

export type ICombinedPermissions = ITeamPermissions &
  IMachinePermissions &
  IUserPermissions;

export const DEFAULT_COMBINED_PERMISSIONS: ICombinedPermissions = {
  machine_lists: false,
  team_lists: false,
  mlb_stats_api: false,
};
